var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTnd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9989 18.0073C15.1686 18.0073 17.7381 15.4378 17.7381 12.2682C17.7381 9.09855 15.1686 6.52905 11.9989 6.52905C8.82927 6.52905 6.25977 9.09855 6.25977 12.2682C6.25977 15.4378 8.82927 18.0073 11.9989 18.0073Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.707 10.072L13.6915 11.4288L15.2861 10.9118L14.3 12.2674L15.2844 13.6242L13.6904 13.1052L12.7043 14.4608L12.7053 12.7845L11.1113 12.2655L12.7059 11.7485L12.707 10.072Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3044 15.6568C11.4315 15.6568 9.91309 14.1384 9.91309 12.2655C9.91309 10.3926 11.4315 8.87418 13.3044 8.87418C13.8884 8.87418 14.4379 9.02183 14.9176 9.2818C14.165 8.54582 13.1359 8.09155 12.0001 8.09155C9.69494 8.09155 7.82617 9.96027 7.82617 12.2654C7.82617 14.5706 9.69494 16.4393 12.0001 16.4393C13.1359 16.4393 14.1651 15.9851 14.9176 15.2491C14.4379 15.5091 13.8884 15.6568 13.3044 15.6568Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TND.92c66a7c5ffa7b36876b5513d3493673.svg";